import { Routes } from '@angular/router';
import { CookieSettingsGuard } from '@teamfoster/sdk/cookie-ngrx';
import { DictionaryGuard } from '@teamfoster/sdk/dictionary-ngrx';
import { MenuGuard } from '@teamfoster/sdk/menu-ngrx';
import { NotFoundComponent } from './404.component';
import { ActivePortalGuard, SwitcherPortalsGuard } from './portals/guards';

const appGuards = [CookieSettingsGuard, DictionaryGuard, MenuGuard, SwitcherPortalsGuard];

const contentPages = ['pagina', 'zakelijk', 'talentontwikkeling', 'project']; // content type as start of the URL
const contentPageRoutes: Routes = contentPages.map(path => ({
  path,
  pathMatch: 'prefix',
  loadChildren: () => import('./content/content.routes').then(m => m.routes),
  canActivate: [...appGuards],
}));

export const routes: Routes = [
  {
    path: '',
    canActivate: [ActivePortalGuard],
    children: [
      {
        path: 'styleguide',
        loadChildren: () => import('./styleguide/styleguide.routes').then(m => m.routes),
        canActivate: [...appGuards],
      },
      {
        path: 'contentblokken',
        pathMatch: 'prefix',
        loadChildren: () => import('./content-blocks/content-blocks.routes').then(m => m.routes),
        canActivate: [...appGuards],
      },
      ...contentPageRoutes,
      {
        path: 'nieuws',
        pathMatch: 'prefix',
        loadChildren: () => import('./news/news.routes').then(m => m.routes),
        canActivate: [...appGuards],
      },
      {
        path: 'talent',
        pathMatch: 'prefix',
        loadChildren: () => import('./talent-support/talent-support.routes').then(m => m.routes),
        canActivate: [...appGuards],
      },
      {
        path: 'voorstelling',
        pathMatch: 'prefix',
        loadChildren: () => import('./events/events.routes').then(m => m.routes),
        canActivate: [...appGuards],
      },
      {
        path: 'zoeken',
        pathMatch: 'prefix',
        loadChildren: () => import('./search/search.routes').then(m => m.routes),
        canActivate: [...appGuards],
      },
      {
        path: '404',
        component: NotFoundComponent,
        canActivate: [...appGuards],
      },
      {
        path: '500',
        component: NotFoundComponent,
        canActivate: [...appGuards],
      },
      {
        path: '',
        pathMatch: 'prefix',
        loadChildren: () => import('./landing-pages/landing-pages.routes').then(m => m.routes),
        canActivate: [...appGuards],
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/404',
  },
];
